document.addEventListener('DOMContentLoaded', () => {
  const inited = new WeakSet();

  const setupContainer = (secondaryImages) => {
    if (!secondaryImages || inited.has(secondaryImages)) return;

    const mediaItems = Array.from(secondaryImages.querySelectorAll('.product-gallery__media'));
    if (mediaItems.length === 0) return;

    const getVisibleItems = () => mediaItems.filter(item => !item.hasAttribute('hidden') && !item.classList.contains('static-image'));

    const getCounterEls = () => {
      const container = secondaryImages.closest('.product-gallery__secondary-images-container');
      const scope = container || secondaryImages.closest('product-gallery') || document;
      return {
        current: scope.querySelector('.product-gallery__counter .current-image'),
        total: scope.querySelector('.product-gallery__counter .total-images')
      };
    };

    const updateCounter = (index, total) => {
      const { current, total: totalEl } = getCounterEls();
      if (current && totalEl) {
        current.textContent = String(index + 1);
        totalEl.textContent = String(total);
      }
    };

    let isNavigating = false;
    const wheelHandler = (e) => {
      if (!e || typeof e.deltaY !== 'number') return;
      const visibleItems = getVisibleItems();
      if (visibleItems.length === 0) return;

      if (e.cancelable) e.preventDefault();
      if (isNavigating) return;

      const currentTop = secondaryImages.scrollTop;
      let targetItem = null;

      if (e.deltaY > 0) {
        for (let i = 0; i < visibleItems.length; i++) {
          const item = visibleItems[i];
          if (item.offsetTop > currentTop + 1) { targetItem = item; break; }
        }
        if (!targetItem) targetItem = visibleItems[visibleItems.length - 1];
      } else if (e.deltaY < 0) {
        for (let i = visibleItems.length - 1; i >= 0; i--) {
          const item = visibleItems[i];
          if (item.offsetTop < currentTop - 1) { targetItem = item; break; }
        }
        if (!targetItem) targetItem = visibleItems[0];
      } else {
        return;
      }

      isNavigating = true;
      const itemIndex = visibleItems.indexOf(targetItem);
      updateCounter(itemIndex, visibleItems.length);

      secondaryImages.scrollTo({ top: targetItem.offsetTop, behavior: 'smooth' });
      setTimeout(() => { isNavigating = false; }, 500);
    };

    secondaryImages.addEventListener('wheel', wheelHandler, { passive: false });

    const scrollHandler = () => {
      if (isNavigating) return;
      const visibleItems = getVisibleItems();
      if (visibleItems.length === 0) return;
      const scrollTop = secondaryImages.scrollTop;
      let currentIndex = 0;
      for (let i = 0; i < visibleItems.length; i++) {
        if (visibleItems[i].offsetTop > scrollTop + 10) break;
        currentIndex = i;
      }
      updateCounter(currentIndex, visibleItems.length);
    };
    secondaryImages.addEventListener('scroll', scrollHandler, { passive: true });

    const visibleItems = getVisibleItems();
    if (visibleItems.length) updateCounter(0, visibleItems.length);

    inited.add(secondaryImages);
  };

  const scanAndInit = () => {
    document.querySelectorAll('.modal--quick-buy .product-gallery__secondary-images').forEach(setupContainer);
  };

  const observer = new MutationObserver(() => scanAndInit());
  observer.observe(document.documentElement || document.body, { childList: true, subtree: true });

  scanAndInit();
  window.addEventListener('load', scanAndInit);
});
